module.exports = __webpack_public_path__ + "static/media/img_txt_section03_5.a0b55ca4.png";